import React from "react";
import { motion } from "framer-motion";
import phoneBg from "../../Assets/Images/Hero Block.png";
import businessIcon from "../../Assets/Images/Start-Business-icon.png";
import soloDeveloper from "../../Assets/Images/Solo-Developer-icon.png";
import { Link } from "react-router-dom";
import "./NewContact.css";

const NewContact = () => {
  return (
    <div
      className="new-contact-content"
      style={{
        position: "",
        zIndex: "5",
        marginBottom: "",
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      {/* Background Section */}
      <div style={{ position: "relative", width: "100%" }}>
        <img
          className="phone-bg-img"
          src={phoneBg}
          alt="Background"
          style={{
            width: "100%",

            objectFit: "cover",
            filter: "brightness(0.9)",
          }}
        />
        <div
          className="text-section"
          style={{ background: "none", width: "100%" }}
        >
          <h2 className="new-contact-heading">
            Ready To Talk, Or Still Thinking It Through?
          </h2>
          <p className="new-contact-text">
            Most conversations start with a half-formed idea or a problem that
            has been bothering teams for a while. You do not need a perfect
            brief to reach out. Sometimes the first step is simply having the
            right conversation.
          </p>
        </div>
      </div>

      {/* Cards Section */}
      <div
        className=" card-container"
        style={{
          marginBottom: "5rem",
        }}
      >
        <div className="row justify-content-center">
          {/* Card 1 */}
          <div className="col-md-5 col-sm-10 mb-4">
            <div
              className="card shadow-lg border-0"
              style={{
                background: "#FAFAFA",
                borderRadius: "20px",
                padding: "30px 20px",
                textAlign: "start",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <img
                  src={businessIcon}
                  alt="Business Icon"
                  style={{
                    width: "50px",
                    height: "50px",
                    marginBottom: "15px",
                  }}
                />
                <h4
                  className="card_heading"
                  style={{
                    fontWeight: "600",
                    marginBottom: "16px",
                    marginTop: "16px",
                  }}
                >
                  Building Or Fixing A Product
                </h4>
                <p
                  style={{
                    fontSize: "1.5rem",
                    color: "#616161",
                    lineHeight: "2.4rem",
                    marginBottom: "25px",
                  }}
                >
                  If you are planning a new platform, improving an existing
                  system, or need clarity around technology decisions, this is
                  where the conversation begins.
                </p>
              </div>

              {/* Button fixed at bottom */}
              <Link to="/contact-us/build-business">
                <motion.button
                  type="button"
                  className="btn  px-5 py-3 rounded-pill align-self-start"
                  initial={{
                    backgroundColor: "#19BDDE",
                    boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
                  }}
                  whileHover={{
                    backgroundColor: "#12869E",
                    scale: 1.05,
                    boxShadow: "none",
                  }}
                  transition={{ duration: 0.2 }}
                  style={{
                    border: "none",
                    color: "#fff",
                    fontWeight: "500",
                    fontSize: "1.7rem",
                    marginTop: "auto", // ensures it stays at bottom
                  }}
                >
                  Talk About Your Project
                </motion.button>
              </Link>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-5 col-sm-10 mb-4">
            <div
              className="card contactCard_2 shadow-lg border-0"
              style={{
                background: "#FAFAFA",
                borderRadius: "20px",
                padding: "30px 20px",
                textAlign: "start",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <img
                  src={soloDeveloper}
                  alt="Solo Developer Icon"
                  style={{
                    width: "50px",
                    height: "50px",
                    marginBottom: "15px",
                  }}
                />
                <h4
                  className="card_heading"
                  style={{
                    fontWeight: "600",
                    marginBottom: "16px",
                    marginTop: "16px",
                  }}
                >
                  Growing Your Team Without Growing Headcount
                </h4>
                <p
                  style={{
                    fontSize: "1.5rem",
                    color: "#616161",
                    lineHeight: "2.4rem",
                    marginBottom: "25px",
                  }}
                >
                  Quad Theory Ltd helps businesses expand their development
                  capacity by adding skilled developers or dedicated teams
                  without the overhead of full-time hiring.
                </p>
              </div>

              {/* Button fixed at bottom */}
              <Link to="/contact-us/hiring-team">
                <motion.button
                  type="button"
                  className="btn px-5 py-3 rounded-pill align-self-start"
                  initial={{
                    backgroundColor: "#19BDDE",
                    boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
                  }}
                  whileHover={{
                    backgroundColor: "#12869E",
                    scale: 1.05,
                    boxShadow: "none",
                  }}
                  transition={{ duration: 0.2 }}
                  style={{
                    border: "none",
                    color: "#fff",
                    fontWeight: "500",
                    marginTop: "auto",
                    fontSize: "1.7rem",
                  }}
                >
                  Hire Developers
                </motion.button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewContact;
